import { useState } from "react";
import Navbar from "../components/Navbar";
import Intro from "../components/Intro";
import Hero from "../components/Hero";
import BrandMarquee from "../components/BrandMarquee";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Results from "../components/Results";
import GmbAudit from "../components/GmbAudit";
import Testimonials from "../components/Testimonials";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";

export default function Home() {
  const [introDone, setIntroDone] = useState(false);

  return (
    <div className="relative bg-white">
      <Intro onDone={() => setIntroDone(true)} />
      <Navbar />
      <main>
        <Hero start={introDone} />
        <BrandMarquee />
        <Services />
        <Manifesto />
        <Results />
        <GmbAudit />
        <Testimonials />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
